import { motion } from "framer-motion";
import { memo } from "react";

export const ConsultantCTA = memo(() => {
  const whatsappUrl = `https://wa.me/5583986147064?text=${encodeURIComponent("Olá! Vim do site p2propaineliptv.com.br, gostaria de mais informações.")}`;

  const consultants = [
    "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80&w=120&h=120",
    "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=120&h=120",
    "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&q=80&w=120&h=120"
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="flex justify-center -space-x-4 mb-8">
          {consultants.map((src, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: i * 0.1 }}
              viewport={{ once: true }}
              className="w-16 h-16 rounded-full border-4 border-[#0a0c10] overflow-hidden shadow-2xl relative z-10"
            >
              <img src={src} alt="Consultor de revenda IPTV P2 PRO" className="w-full h-full object-cover" />
            </motion.div>
          ))}
        </div>

        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-3xl md:text-5xl font-black tracking-tighter mb-6 uppercase italic"
        >
          Ainda com <span className="text-electric">dúvidas?</span>
        </motion.h2>
        
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-muted-foreground text-lg mb-10 max-w-xl mx-auto italic"
        >
          Nossos consultores especializados estão online agora para ajudar você a escolher a melhor estratégia para sua revenda.
        </motion.p>

        <div className="flex flex-col items-center gap-6">
          <motion.a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="relative group inline-flex items-center gap-4 bg-[#217346] text-white px-10 py-5 rounded-full font-black text-xs uppercase tracking-[0.2em] shadow-[0_15px_40px_rgba(33,115,70,0.3)] transition-all overflow-hidden"
          >
            <div className="absolute inset-0 bg-white/10 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500" />
            <span className="relative z-10 font-black text-white">Falar com nossos consultores</span>
            <div className="relative w-3 h-3 bg-white rounded-full">
              <div className="absolute inset-0 bg-white rounded-full animate-ping" />
            </div>
          </motion.a>
          
          <div className="flex items-center gap-2 text-[11px] font-black uppercase tracking-[0.3em] text-[#2ebd5e] animate-pulse">
            <div className="w-2.5 h-2.5 bg-[#2ebd5e] rounded-full" />
            Atendimento Online Agora
          </div>
        </div>
      </div>
    </section>
  );
});

ConsultantCTA.displayName = "ConsultantCTA";
